import { sortSnippetResults } from 'in-meeting-experience-ui-components/utils/comments';
import { getInMeetingExperienceProxyApiUrl } from 'in-meeting-experience-ui-components/utils/general';
import noAuthClient from '../../utils/apiClient';
const API_PROXY_BASE = getInMeetingExperienceProxyApiUrl();
export const fetchRenderedContent = ({
  id,
  cb
}) => noAuthClient.get(`${API_PROXY_BASE}/v1/snippets/${id}/render`).finally(() => {
  if (typeof cb === 'function') cb();
});
export const fetchUnrenderedContent = ({
  id
}) => noAuthClient.get(`${API_PROXY_BASE}/v1/snippets/${id}`);
export const searchSnippets = ({
  count = 20,
  offset = 0,
  query = ''
}) => noAuthClient.post(`${API_PROXY_BASE}/v2/salescontentsearch/search`, {
  data: {
    contentTypesToHydrate: ['SNIPPET'],
    filters: [{
      field: 'content_type',
      values: ['SNIPPET']
    }],
    limit: count,
    offset,
    query
  }
}).then(response => sortSnippetResults({
  response,
  query
}));